<div class="stocks-widget">
	<app-positions [widget]="widget()" />
</div>
